module.exports = __webpack_public_path__ + "static/media/growth.ba529e25.png";